import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import Button from 'components/Form/Button';
import Edit from 'svg/edit.svg';
import Sync from 'svg/sync.svg';
import Hcp from 'modules/Hcp';
import { useAction } from 'hooks';
import App from 'modules/App';
import * as constants from '../../constants';
import styles from '../Results/Results.pcss';
const FeaturesActions = ({ isDisabled })=>{
    const sharingRequest = useSelector(Hcp.selectors.sharingRequest);
    const openModal = useAction(App.actions.openModal);
    const setIsPatientDataFullComparison = useAction(Hcp.actions.setIsPatientDataFullComparison);
    const isButton = sharingRequest && sharingRequest.sharingStatus === 'Approved';
    const onComparePatientData = ()=>{
        setIsPatientDataFullComparison(true);
        openModal(Hcp.constants.SYNC_DATA_MISMATCH_MODAL);
    };
    const onOpenModal = ()=>openModal(constants.PROFILE_EDIT_MODAL);
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx(Button, {
                styleModifier: "transparent",
                className: `${styles.patient__feature__action} mb-2`,
                isDisabled: isDisabled,
                onClick: onOpenModal,
                children: /*#__PURE__*/ _jsx(Edit, {
                    className: styles.patient__feature__icon
                })
            }),
            isButton && /*#__PURE__*/ _jsx(Button, {
                styleModifier: "transparent",
                className: styles.patient__feature__action,
                isDisabled: isDisabled,
                onClick: onComparePatientData,
                children: /*#__PURE__*/ _jsx(Sync, {
                    className: styles.patient__feature__icon
                })
            })
        ]
    });
};
export default FeaturesActions;
